<template>
  <b-row no-gutters>
    <b-col
      :cols="$slots.bundled ? 8 : 12"
      :md="$slots.bundled ? 8 : 4"
      class="dd"
    >
      <b-form-select
        class="form-control test-select-master-item-type"
        value-field="id"
        text-field="name"
        v-model="order_item_type_id"
        :options="itemTypes"
        :disabled="disabled"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>{{
            $translate("select_item_type")
          }}</b-form-select-option>
        </template>
      </b-form-select>
    </b-col>
    <b-col cols="4" class="dd mt-2" v-if="$slots.bundled">
      <slot name="bundled"></slot>
    </b-col>
    <b-col :cols="$slots.bundled ? 12 : undefined">
      <vue-typeahead-bootstrap
        v-model="searchedMasterItem"
        :data="masterItems"
        :serializer="s => `${s.name}  -  ${s.ext_reference_code}`"
        @hit="triggerMasterItem"
        @input="lookupMasterItems"
        @queryOptionsValue="setQueryOptionsValue"
        :placeholder="$translate('search_master_items')"
        :disabled="disabled"
      >
        <!-- Begin custom suggestion slot -->
        <template slot="suggestion" slot-scope="{ data }">
          <div class="d-flex align-items-center">
            {{ data.name }}  -  {{ data.ext_reference_code }}
          </div>
        </template>
      </vue-typeahead-bootstrap>
    </b-col>
  </b-row>
</template>
<script>
import VueTypeaheadBootstrap from "@/components/VueTypeAhead/VueTypeaheadBootstrap";

import { debounce } from "lodash";
export default {
  components: { VueTypeaheadBootstrap },
  props: {
    value: {
      type: [Number, null],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    itemTypeId: {
      type: [Number, null],
      default: null,
    },
    orderType: {
      type: [Number, null],
      default: null,
    },
    isProductOnly: {
      type: Boolean,
      default: false,
    },
    isBundledOnly: {
      type: Boolean,
      default: false,
    },
    parentSearchedText: {
      type: [String, null],
      default: null,
    },
  },
  data: () => ({
    searchedMasterItem: "",
    order_item_type_id: null,
    filters: {},
  }),
  computed: {
    masterItems() {
      return this.$store.state.masterItem.items;
    },
    masterItem() {
      return this.$store.state.masterItem.item;
    },

    itemTypes() {
      const orderTypeItem = this.$store.state.orderType.item;
      console.log("orderTypeItem", orderTypeItem);
      const entities = this.$store.getters["transactionType/entities"];
      const { orderType: order_type_id, isProductOnly } = this;

      const { transaction_type } = orderTypeItem || {};
      const { entity } = transaction_type || {};

      const checkProductItem = (item) => {
        const itemIsProduct = !item.is_task && !item.is_discount;
        console.log("itemIsProduct", itemIsProduct);
        if (order_type_id) {
          return entities.Customer == entity || itemIsProduct;
        }
        if (isProductOnly) {
          return itemIsProduct;
        }
        return true;
      };
      return this.$store.state.itemType.items.filter(checkProductItem);
    },
  },
  watch: {
    parentSearchedText: function (val) {
      this.searchedMasterItem = val || "";
    },
    itemTypeId: function (_type) {
      this.order_item_type_id = _type || null;
    },

    order_item_type_id: function (_type, from) {
      if (_type && from) {
        this.triggerMasterItem();
        this.searchedMasterItem = "";
      }
      this.$emit("update-item-type", _type);
      this.$emit("update:item-type-id", _type);
    },
    searchedMasterItem: function (to, from) {
      if (from && to === "") {
        this.$emit("input", null);
        this.$emit("set-master-item", null);
      }
      this.$emit("update:parent-searched-text", to);
    },
    value: async function (id) {
      await this.setValue(id);
    },
    orderType: function (val) {
      this.$store.dispatch("orderType/fetchById", val);
    },
  },
  created() {
    this.$store.dispatch("itemType/fetchAll");
  },
  mounted() {
    this.order_item_type_id = this.itemTypeId || null;
    this.setValue(this.value);
    if (this.orderType) {
      this.$store.dispatch("orderType/fetchById", this.orderType);
    }
  },
  methods: {
    async setValue(id) {
      if (id) {
        try {
          const _masterItem = await this.$store.dispatch(
            "masterItem/fetchByIdFunction",
            id
          );
        
          this.order_item_type_id = _masterItem.order_item_type_id;
          this.searchedMasterItem = _masterItem.name+' - '+_masterItem.ext_reference_code;
          this.triggerMasterItem(_masterItem);
        } catch (err) {
          console.log("err", err);
        }
      }
    },
    triggerMasterItem(_masterItem = {}) {
      this.$emit("input", _masterItem.id);
      this.$emit("set-master-item", _masterItem);
    },
    setQueryOptionsValue(val) {
      this.queryOptionsValue = val;
      this.lookupMasterItems();
    },
    lookupMasterItems: debounce(function () {
      const {
        searchedMasterItem: query,
        order_item_type_id,
        isBundledOnly,
        queryOptionsValue = "starts_with",
      } = this;
      console.log("query", query);
      const is_bundled = isBundledOnly ? 1 : 0;
      const filters = { order_item_type_id, is_bundled, queryOptionsValue };
      console.log("filters", filters);
      
      if(query.length < 3){
        return;
      }
      if (query != "")
        this.$store.dispatch("masterItem/fetchAll", { query, filters });
    }, 500),
  },
};
</script>
